import { useEffect, useState } from "react";
import {
  TextEditor,
  RightMainContainer,
  HeaderContainer,
  PrimaryHeading,
  IconWrapper,
  BodyContainer,
  MainButton,
  InputField,
  Loader,
} from "commonUI";
import { SaveIcon, BackArrow } from "allIcons";
import {
  useEmailTemplates,
  useUpdateEmailTemplate,
} from "hooks/emailTemplates";
import { useParams } from "react-router-dom";
import { isEqual, useUtilities } from "helpers";
import { t } from "i18next";

export default function EmailSetting() {
  const [inputValue, setInputValue] = useState({
    email_title: "",
    email_subject: "",
    email_body: "",
  });
  const { id } = useParams();
  const { notification } = useUtilities();

  const { data: emailTemplates, isLoading: loadingEmailTemplates } =
    useEmailTemplates();
  const { mutate: updateEmailTemplate, isLoading: updatingEmailTemplate } =
    useUpdateEmailTemplate();

  useEffect(() => {
    if (!emailTemplates || loadingEmailTemplates || isEqual(id, "add")) return;
    const template = emailTemplates.find((ele) => isEqual(ele.id, id));

    if (template) {
      setInputValue({
        email_subject: template.email_subject,
        email_body: template.email_body,
        email_title: template.email_title,
      });
    }
  }, [loadingEmailTemplates, emailTemplates, id]);

  const handleSaveChanges = () => {
    if (isEqual(id, "add")) return;

    if (!inputValue.email_subject || !inputValue.email_body) {
      notification({
        type: "error",
        message: !inputValue.email_subject
          ? t("accountSettings.emailTemplates.input.subject.required")
          : t("accountSettings.emailTemplates.input.message.required"),
      });
      return;
    }
    updateEmailTemplate({
      id,
      ...inputValue,
    });
  };

  return (
    <>
      <RightMainContainer>
        <Loader loader="block" show={updatingEmailTemplate} />
        <HeaderContainer>
          <IconWrapper>
            <BackArrow />
            <PrimaryHeading>{inputValue.email_title}</PrimaryHeading>
          </IconWrapper>
          <MainButton onClick={handleSaveChanges}>
            <SaveIcon />
            {t("button.saveChanges")}
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField
            label={t("accountSettings.emailTemplates.input.subject.label")}
            placeholder={t(
              "accountSettings.emailTemplates.input.subject.placeholder"
            )}
            value={inputValue.email_subject}
            className="mb-3"
            setValue={(value) =>
              setInputValue({ ...inputValue, email_subject: value })
            }
          />
          <TextEditor
            label={t("accountSettings.emailTemplates.input.message.label")}
            placeholder={t(
              "accountSettings.emailTemplates.input.message.placeholder"
            )}
            height={300}
            options={true}
            reRender={inputValue.email_body}
            value={inputValue.email_body}
            setValue={(value) => setInputValue({ ...inputValue, email_body: value })}
          />
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
